import ProductCardView from './product-card-view'

export default ProductCardView
